<template>
  <div id="cart-finish" class="noprint-top-bottom" v-if="isImagefinish">
    <div class="cart-finish-header noprint">
      <div class="check">
        <img src="@/images/check.png" alt="check" />
      </div>
      <p>下單成功！感謝您的購買</p>
      <div>
        <span class="note" v-if="isLogin">
          因黃金屬於即時報價商品，若超過24小時未匯款此訂單將無效。請於24小時內至以下ATM資訊進行轉帳，如轉帳完成請前往個人頁面中的
          <span @click="goOrderDetail" class="to-orderdetail-text"
            >訂單詳情</span
          >內回報付款，或加入官方 Line@（ ID: @nxf8131i ）。
        </span>
        <div v-else>
          <span class="note"
            >因黃金屬於即時報價商品，若超過24小時未匯款此訂單將無效。請於24小時內至以下ATM資訊進行轉帳，如轉帳完成，請加入官方
            Line@（ ID: @nxf8131i ）或是電話聯絡 (06)2266-300
            進行付款回報。歡迎下次購買時，加入金牌會員，可於會員訂單中進行付款回報以及查詢訂單細節哦！</span
          >
          <img
            src="https://qr-official.line.me/L/M25Jjb7obw.png"
            class="qrcode"
          />
        </div>
        <div class="ATM-info">
          <h4 class="ATM-info-title">ATM匯款資訊</h4>
          <table class="ATM-info-text">
            <tr>
              <td class="text-right">戶名</td>
              <td class="text-left">金牌王國金行許洋洋</td>
            </tr>
            <tr>
              <td class="text-right">分行名稱</td>
              <td class="text-left">彰化銀行 台南分行</td>
            </tr>
            <tr>
              <td class="text-right">銀行代號</td>
              <td class="text-left">009</td>
            </tr>
            <tr>
              <td class="text-right">銀行帳號</td>
              <td class="text-left">64020188887900</td>
            </tr>
            <tr>
              <td class="text-right">應繳金額</td>
              <td class="text-left">TWD {{ orderDetail.sum }}</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- <p class="note" v-else>因黃金屬於即時報價商品，若超過24小時未匯款此訂單將無效。確認您的付款與購買品項後，出貨時間約四個工作天，出貨後會另寄 E-mail 通知。</p> -->
    </div>
    <div class="main-content">
      <div class="shopping-detail">
        <h2 class="shopping-list noprint-top-bottom">購物明細</h2>
        <div class="order-list-wrap">
          <div
            class="order-list"
            v-for="(item, index) in products"
            :key="index"
          >
            <div class="item-img">
              <img v-bind:src="item.imageUrl" alt="item" />
            </div>
            <div class="item-name">
              <span>{{ item.shape }}-{{ item.style }}</span>
              <span
                >{{ item.size.length }}{{ item.size.unit
                }}{{ item.size.weight }}錢{{ item.size.way }}</span
              >
              <span
                >( 配件選擇：{{ item.accessory_name }} - TWD
                {{ item.accessory_price }} )</span
              >
            </div>
            <div class="item-amount">
              <span class="mobile-display">數量：</span>
              <span>{{ item.amount }}</span>
              <span class="pc-display">個</span>
            </div>
            <div class="item-price">
              <span class="mobile-display">金額：</span>
              <span
                >TWD
                {{
                  parseInt(item.total) + item.accessory_price * item.amount
                }}</span
              >
            </div>
          </div>
          <div class="calculate">
            <div class="calculate-total-title">
              <span>小計</span>
            </div>
            <div class="calculate-total">
              <span>TWD {{ orderDetail.productTotal }}</span>
            </div>
            <div class="calculate-delivery-title">
              <span>運費</span>
            </div>
            <div class="calculate-delivery">
              <span>TWD {{ orderDetail.freight }}</span>
            </div>
          </div>
          <div class="total-payment-wrap">
            <div>
              <span>總額</span>
              <span v-if="this.$store.getters.getSpecialMemberState !== 1"
                >(包含營業稅)</span
              >
            </div>
            <div class="total-payment">
              <span>TWD {{ orderDetail.sum }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="order-detail">
        <h2 class="noprint-top-bottom">訂單明細</h2>
        <div>
          <h3 class="noprint-top">訂單編號 {{ orderDetail.orderId }}</h3>
          <p>成立時間：{{ orderDetail.createTime }}</p>
        </div>
        <div>
          <h3>付款方式</h3>
          <p>ATM轉帳</p>
        </div>
        <div class="delivery">
          <h3>寄送資訊</h3>
          <p>寄送地區：{{ orderDetail.receiverInfo.country }}</p>
          <p>
            寄送地址：{{ orderDetail.receiverInfo.postalCode
            }}{{ orderDetail.receiverInfo.address }}
          </p>
          <p>寄送方式：{{ orderDetail.receiverInfo.sendWay }}</p>
        </div>
        <div class="receiver">
          <h3>收貨人資訊</h3>
          <p>收件人：{{ orderDetail.receiverInfo.full_name }}</p>
          <p>手機：{{ orderDetail.receiverInfo.phone }}</p>
          <p>電子信箱：{{ orderDetail.receiverInfo.email }}</p>
        </div>
        <div class="invoice">
          <h3>發票資訊</h3>
          <p v-if="orderDetail.receiverInfo.invoiceType !== '同業'">
            發票種類 : {{ orderDetail.receiverInfo.invoiceType }}
          </p>
          <p v-if="orderDetail.receiverInfo.invoiceType !== '同業'">
            抬頭 : {{ orderDetail.receiverInfo.invoiceHead }}
          </p>
          <p v-if="orderDetail.receiverInfo.invoiceType !== '同業'">
            統一編號：{{ orderDetail.receiverInfo.invoiceNum }}
          </p>
          <p v-if="orderDetail.receiverInfo.invoiceType == '同業'">無</p>
        </div>
      </div>
    </div>
    <div class="button noprint">
      <router-link to="/gold/homepage">
        <button>返回首頁</button>
      </router-link>
    </div>
  </div>
  <div class="load" v-else>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";

export default {
  name: "CartFinish",
  data() {
    return {
      orderDetail: "",
      products: "",
      isImagefinish: false,
    };
  },
  created() {
    axios({
      url: this.$store.getters.getGlobalUrl + "orders/" + this.$route.params.id,
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    })
      .then((response) => {
        this.orderDetail = response.data;
        this.products = response.data.product;
        this.products.forEach((item) => {
          item.size.way = this.$store.getters.getTransformWay(item.size.way);
          item.size.unit = this.$store.getters.getTransformUnit(item.size.unit);
        });
        this.baseToImg();
      })
      .catch((e) => {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      });
    // 清掉cookie
    localStorage.removeItem("cartorder");
    localStorage.removeItem("cartorderNote");
    Cookies.remove("receiptInfo");
    Cookies.remove("infoEqual");
    if (JSON.parse(localStorage.getItem("cartorder")) === null) {
      this.$store.dispatch("updateCartOrderNum", 0);
    } else {
      this.$store.dispatch(
        "updateCartOrderNum",
        JSON.parse(localStorage.getItem("cartorder")).length
      );
    }
  },
  watch: {
    products: {
      handler() {
        if (typeof this.products !== "undefined") {
          //check img loading
          let checkNum = 0;
          this.products.forEach((item) => {
            if (item.imageUrl.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.products.length) {
            this.isImagefinish = true;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    baseToImg() {
      this.products.forEach((item) => {
        axios({
          url: `${item.imageUrl}`,
          method: "get",
        })
          .then((response) => {
            item.imageUrl = response.data;
          })
          .catch((e) => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      });
    },
    goOrderDetail() {
      this.$store.dispatch("setSingleId", this.$route.params.id);
      let size = this.$store.getters.getDeviceSize;
      if (size > 585) {
        this.$router.push("/gold/member/member_orderdetail");
      } else {
        this.$router.push("/gold/member_mobile/member_orderdetail");
      }
    },
  },
  computed: {
    isLogin() {
      return this.$store.getters.getToken !== "";
    },
  },
};
</script>

<style scoped lang="scss">
@media print {
  #cart-finish.noprint-top-bottom {
    padding-top: 0;
    padding-bottom: 0;
  }
  .cart-finish-header.noprint {
    display: none;
  }
  .shopping-list.noprint-top-bottom {
    padding: 5px 0;
  }
  .order-detail {
    .noprint-top-bottom {
      padding: 5px 0;
      margin: 0;
    }
    .noprint-top {
      margin-top: 0;
    }
  }
  .button.noprint {
    display: none;
  }
}
#cart-finish {
  padding: 110px 120px;
  color: $secondaryDeepColor1;
  @include betweenTableTablePro {
    padding: 110px 30px;
  }
  @include table {
    padding: 90px 16px;
  }
  .cart-finish-header {
    margin-bottom: 30px;
    // border-bottom: 1px solid $primaryDeepColor;
    .to-orderdetail-text {
      color: #4a90e2;
      cursor: pointer;
    }
    .ATM-info {
      padding: 10px 0;
      background-color: lighten($primaryDeepColor, 40%);
      margin-top: 20px;
      .ATM-info-title {
        margin-top: 0;
      }
      .ATM-info-text {
        margin: auto;
        .text-right {
          text-align: right;
        }
        .text-left {
          text-align: left;
          padding-left: 15px;
        }
      }
    }
  }
  .qrcode {
    width: 100px;
    height: 100px;
    display: block;
    margin: 0 auto;
  }
  .cart-finish-header p:nth-of-type(1) {
    font-size: 24px;
    font-weight: bold;
    margin: 16px;
  }
  .cart-finish-header p:nth-of-type(2) {
    font-size: 17px;
    font-weight: 600;
    margin: 0;
    margin-bottom: 16px;
  }
  .note {
    color: $secondaryColor2;
  }
  .check {
    height: 70px;
    width: 70px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
}
.same-trade {
  padding: 25px 10px;
  border-bottom: 1px solid $primaryDeepColor;
  .same-trade-content {
    background-color: rgba($primaryDeepColor, 0.2);
    text-align: center;
    font-size: 17px;
    padding-top: 20px;
    padding-bottom: 28px;
  }
  .grid-container {
    display: grid;
    grid-template-columns: auto auto;
    grid-row-gap: 5px;
    grid-column-gap: 15px;
  }
  .ATM-title {
    font-size: 20px;
    margin-bottom: 15px;
  }
  .transfer-title {
    text-align: right;
  }
  .transfer-text {
    text-align: left;
  }
}
.shopping-detail {
  text-align: left;
  flex-basis: 40%;
  @include table {
    max-width: 600px;
    margin: 0 auto;
    flex-basis: 100%;
  }

  h2 {
    color: $secondaryDeepColor1;
    font-size: 24px;
    line-height: 31px;
    padding: 16px 0px 16px 0px;
    margin: 0;
    display: block;
  }
  .shopping-list {
    border-bottom: 1px solid $primaryDeepColor;
  }
  span {
    font-size: 17px;
  }
}

.main-content {
  display: flex;
  flex-direction: row-reverse;
  border-bottom: 1px solid $primaryDeepColor;

  @include table {
    flex-wrap: wrap;
  }
}

.order-list {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 1fr auto;
  align-items: center;
  color: $secondaryDeepColor1;
  border-bottom: 1px solid $primaryDeepColor;
  font-size: 15px;
  justify-content: space-between;
  padding: 16px;
  @include table {
    padding: 0;
    grid-template-columns: 1fr;
  }

  .item-img {
    grid-column: 1 / span 3;
    @include table {
      grid-column: 1;
    }

    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
      padding: 16px 16px 16px 0;
      @include table {
        padding: 16px;
      }
    }
    p {
      display: inline-block;
    }
  }

  .item-name {
    padding-bottom: 16px;
    span {
      display: block;
    }
  }
  .item-amount {
    text-align: center;
    line-height: 31px;
    @include table {
      text-align: left;
    }
  }
  .item-price {
    text-align: right;
    line-height: 31px;
    @include table {
      text-align: left;
    }
  }
}

.calculate {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  color: $secondaryDeepColor1;
  font-size: 15px;
  padding: 16px;
  @include table {
    padding: 0;
  }
  .calculate-total-title {
    span {
      display: block;
      padding-top: 16px;
    }
  }
  .calculate-delivery-title {
    span {
      display: block;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
  .calculate-total {
    text-align: right;
    span {
      display: block;
      padding-top: 16px;
    }
  }
  .calculate-delivery {
    text-align: right;
    span {
      display: block;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
}

.total-payment-wrap {
  display: grid;
  grid-template-columns: 1fr auto;
  color: $secondaryDeepColor1;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  border-top: 1px solid $primaryDeepColor;
  @include table {
    padding-left: 0;
  }

  span {
    display: inline-block;
    font-weight: 800;
  }
  .total-payment {
    font-size: 24px;
    text-align: right;
    padding-left: 7px;
  }
}

.pc-display {
  display: inline-block;
  @include table {
    display: none;
  }
}
.mobile-display {
  display: none;
  @include table {
    display: inline-block;
  }
}

.order-detail {
  padding-bottom: 16px;
  flex-basis: 60%;
  text-align: left;
  h3 {
    font-size: 17px;
  }
  @include table {
    flex-basis: 100%;
    max-width: 600px;
    margin: 0 auto;
  }
}

.delivery,
.receiver,
.invoice {
  p {
    margin: 0;
    line-height: 28px;
  }
  a {
    color: #4a90e2;
    display: inline-block;
    text-decoration: underline;
  }
}
button {
  @extend %button;
  margin-top: 29px;
}
//loading
.load {
  padding-top: 25vh;
  text-align: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
